module.exports = __webpack_public_path__ + "media/1alB-j-jid.8130b8bd.mp3";